// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Global styles for Stream Chat --- */
.str-chat {
  /* Base colors */
  --str-chat__primary-color: #00b894;
  --str-chat__primary-surface-color: #e8fdf7;
  --str-chat__background-color: transparent; 
  --str-chat__text-color: #e5e7eb;
  --str-chat__text-color: #222;
  --str-chat__on-primary-color: #ffffff;

  /* Typography */
  --str-chat__font-family: "Inter", sans-serif;
  --str-chat__font-size: 15px;
  --str-chat__font-weight-bold: 600;

  /* Borders */
  --str-chat__border-radius: 14px;
}

/* --- Message Bubble Customization --- */
.str-chat {
  --str-chat__message-bubble-background-color: #ffffff;
  --str-chat__own-message-bubble-background-color: #00b894;
  --str-chat__own-message-text-color: #ffffff;
  --str-chat__message-bubble-border-radius: 18px;
}

/* --- Message Input Customization --- */
.str-chat {
  --str-chat__message-input-background-color: transparent;
  --str-chat__message-textarea-border-inline-start: none;
  --str-chat__message-input-border-block-start: 1px solid rgba(255,255,255,0.15);
  --str-chat__message-input-border-block-end: 1px solid rgba(255,255,255,0.15);
  --str-chat__message-textarea-border-radius: 12px;
}

/* --- Avatar customization --- */
.str-chat {
  --str-chat__avatar-border-radius: 50%;
  --str-chat__avatar-size: 40px;
}

/* --- Channel Header --- */
.str-chat {
  --str-chat__channel-header-background-color: #e8fdf7;
  --str-chat__channel-header-text-color: #00b894;
  --str-chat__channel-header-border-block-end: 1px solid #c8f5e5;
}

/* --- Message list --- */
.str-chat {
  --str-chat__message-list-background-color: transparent;
}

/* --- Layout container --- */
.chat-container {
  display: flex;
  height: 100vh;
  background: transparent;
}

.str-chat__channel-list {
  width: 280px;
  border-right: 1px solid #ddd;
}
.custom-chat-panel {
  display: flex;
  flex-direction: column;
  background: transparent;
  color: white;
  height: 100%;
}

.chat-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.str-chat__message-list {
  flex: 1 1;
  overflow-y: auto;
  background: transparent;
}

.str-chat__unread-messages-separator,
.str-chat__unread-messages-notification {
  display: none !important;
}

.str-chat__message-input,
.str-chat__message-input-inner,
.str-chat__message-textarea-container,
.str-chat__message-textarea-with-emoji-picker {

  border: none !important;
  background: transparent !important;
}

.str-chat__message-input .str-chat__send-button:disabled svg path {
  fill: white !important;
}

.str-chat__message-textarea-with-emoji-picker textarea {
  background: transparent !important; 
  color: #e5e7eb !important;
  border: none !important;
  box-shadow: none !important;
  padding: 12px 12px !important;
  outline: none !important;
  min-height: 40px !important;
}

.str-chat__message-textarea-with-emoji-picker {
  background: rgba(0, 0, 0, 0.35);
  border-radius: 9999px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  border: none !important;
}


.str-chat__input-flat {
  background-color: transparent !important;
  border-top: 1px solid rgba(255,255,255,0.12);
  display: flex !important;
  padding: 10px 12px !important;
}


.str-chat, .str-chat__container, .str-chat__virtual-list, .str-chat__list {
  background: transparent !important;
}


.str-chat__message-input-inner svg,
.str-chat__message-input-inner .str-chat__icon,
.str-chat__message-input-inner button {
  color: #e5e7eb !important;
  fill: currentColor !important;
  stroke: currentColor !important;
}

.str-chat__message-textarea-with-emoji-picker textarea::placeholder {
  color: rgba(229,231,235,0.75) !important;
}

.str-chat__message-actions-box.str-chat__message-actions-box--open {
  background: white;
}
.str-chat__message-actions-box .str-chat__message-actions-list-item-button:hover {
  background-color: #2F2047 !important;
  color: white !important;
}

.str-chat__quoted-message-reply-to-message {
  color: white;
}

/* Recipient pill in input header */
.recipient-pill {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px 6px 10px;
  border-radius: 9999px;
}

.recipient-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 9999px;
  background: #7c3aed;
  color: #fff;
  font-size: 12px;
}

.recipient-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  border: none;
  color: #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  padding-right: 24px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recipient-select option {
  background: #374151;
  color: #e5e7eb;
  padding: 8px 12px;
}

.recipient-select:focus {
  outline: none;
}

.recipient-caret {
  position: absolute;
  right: 8px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 7px solid #e5e7eb;
  pointer-events: none;
}

/* Message bubble text wrapping */
.str-chat__message-text,
.str-chat__message-text p,
.str-chat__message-text div,
.msg-bubble p {
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto !important;
  max-width: 100% !important;
}

/* Ensure message bubbles handle overflow properly */
.str-chat__message-bubble {
  max-width: 100% !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}

/* Pinned messages container */
.pinned-messages-container {
  margin: 8px 12px;
  padding: 0;
  border-bottom: 0.15px solid #ffffff;
}

.pinned-label-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-left: 44px; 
}

.pinned-label {
  font-size: 12px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}

.pinned-message-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
  position: relative;
}

.pinned-avatar {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
}

.pinned-avatar-image {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.pinned-avatar-fallback {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #52BE80; /* Green color */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  color: white;
}

.pinned-message-bubble {
  flex: 1 1 auto;
  min-width: 0;
  background-color: #242626; /* Dark grey */
  border-radius: 14px;
  padding: 10px 14px;
  color: white;
}

.pinned-message-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
}

.pinned-message-author {
  font-weight: 600;
  color: #52BE80; /* Green color */
}

.pinned-message-time {
  color: #9ca3af; /* Light grey */
  font-size: 11px;
}

.pinned-message-text {
  color: white;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  line-height: 1.4;
}

.pinned-message-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  padding-top: 4px;
}

.pinned-menu-wrapper {
  position: relative;
}

.pinned-menu-button {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: color 0.2s, background-color 0.2s;
}

.pinned-menu-button:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
}

.pinned-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background-color: #374151;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
  min-width: 120px;
  z-index: 1000;
  overflow: hidden;
}

.pinned-menu-dropdown-item {
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  color: #e5e7eb;
  text-align: left;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pinned-menu-dropdown-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.str-chat__user-item--name{
  color: white !important;
}

.str-chat__message-reaction-count{
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/ChatPanel.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;;EAErC,eAAe;EACf,4CAA4C;EAC5C,2BAA2B;EAC3B,iCAAiC;;EAEjC,YAAY;EACZ,+BAA+B;AACjC;;AAEA,yCAAyC;AACzC;EACE,oDAAoD;EACpD,wDAAwD;EACxD,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA,wCAAwC;AACxC;EACE,uDAAuD;EACvD,sDAAsD;EACtD,8EAA8E;EAC9E,4EAA4E;EAC5E,gDAAgD;AAClD;;AAEA,iCAAiC;AACjC;EACE,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,oDAAoD;EACpD,8CAA8C;EAC9C,8DAA8D;AAChE;;AAEA,yBAAyB;AACzB;EACE,sDAAsD;AACxD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,wCAAwC;EACxC,4CAA4C;EAI5C,wBAAwB;EACxB,6BAA6B;AAJ/B;;;AAQA;EACE,kCAAkC;AACpC;;;AAGA;;;EAGE,yBAAyB;EACzB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;;;;EAIE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,UAAU;EACV,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* --- Global styles for Stream Chat --- */\n.str-chat {\n  /* Base colors */\n  --str-chat__primary-color: #00b894;\n  --str-chat__primary-surface-color: #e8fdf7;\n  --str-chat__background-color: transparent; \n  --str-chat__text-color: #e5e7eb;\n  --str-chat__text-color: #222;\n  --str-chat__on-primary-color: #ffffff;\n\n  /* Typography */\n  --str-chat__font-family: \"Inter\", sans-serif;\n  --str-chat__font-size: 15px;\n  --str-chat__font-weight-bold: 600;\n\n  /* Borders */\n  --str-chat__border-radius: 14px;\n}\n\n/* --- Message Bubble Customization --- */\n.str-chat {\n  --str-chat__message-bubble-background-color: #ffffff;\n  --str-chat__own-message-bubble-background-color: #00b894;\n  --str-chat__own-message-text-color: #ffffff;\n  --str-chat__message-bubble-border-radius: 18px;\n}\n\n/* --- Message Input Customization --- */\n.str-chat {\n  --str-chat__message-input-background-color: transparent;\n  --str-chat__message-textarea-border-inline-start: none;\n  --str-chat__message-input-border-block-start: 1px solid rgba(255,255,255,0.15);\n  --str-chat__message-input-border-block-end: 1px solid rgba(255,255,255,0.15);\n  --str-chat__message-textarea-border-radius: 12px;\n}\n\n/* --- Avatar customization --- */\n.str-chat {\n  --str-chat__avatar-border-radius: 50%;\n  --str-chat__avatar-size: 40px;\n}\n\n/* --- Channel Header --- */\n.str-chat {\n  --str-chat__channel-header-background-color: #e8fdf7;\n  --str-chat__channel-header-text-color: #00b894;\n  --str-chat__channel-header-border-block-end: 1px solid #c8f5e5;\n}\n\n/* --- Message list --- */\n.str-chat {\n  --str-chat__message-list-background-color: transparent;\n}\n\n/* --- Layout container --- */\n.chat-container {\n  display: flex;\n  height: 100vh;\n  background: transparent;\n}\n\n.str-chat__channel-list {\n  width: 280px;\n  border-right: 1px solid #ddd;\n}\n.custom-chat-panel {\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  color: white;\n  height: 100%;\n}\n\n.chat-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.chat-main {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.str-chat__message-list {\n  flex: 1;\n  overflow-y: auto;\n  background: transparent;\n}\n\n.str-chat__unread-messages-separator,\n.str-chat__unread-messages-notification {\n  display: none !important;\n}\n\n.str-chat__message-input,\n.str-chat__message-input-inner,\n.str-chat__message-textarea-container,\n.str-chat__message-textarea-with-emoji-picker {\n\n  border: none !important;\n  background: transparent !important;\n}\n\n.str-chat__message-input .str-chat__send-button:disabled svg path {\n  fill: white !important;\n}\n\n.str-chat__message-textarea-with-emoji-picker textarea {\n  background: transparent !important; \n  color: #e5e7eb !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 12px 12px !important;\n  outline: none !important;\n  min-height: 40px !important;\n}\n\n.str-chat__message-textarea-with-emoji-picker {\n  background: rgba(0, 0, 0, 0.35);\n  border-radius: 9999px;\n  padding: 4px 8px;\n  display: flex;\n  align-items: center;\n  border: none !important;\n}\n\n\n.str-chat__input-flat {\n  background-color: transparent !important;\n  border-top: 1px solid rgba(255,255,255,0.12);\n}\n\n.str-chat__input-flat {\n  display: flex !important;\n  padding: 10px 12px !important;\n}\n\n\n.str-chat, .str-chat__container, .str-chat__virtual-list, .str-chat__list {\n  background: transparent !important;\n}\n\n\n.str-chat__message-input-inner svg,\n.str-chat__message-input-inner .str-chat__icon,\n.str-chat__message-input-inner button {\n  color: #e5e7eb !important;\n  fill: currentColor !important;\n  stroke: currentColor !important;\n}\n\n.str-chat__message-textarea-with-emoji-picker textarea::placeholder {\n  color: rgba(229,231,235,0.75) !important;\n}\n\n.str-chat__message-actions-box.str-chat__message-actions-box--open {\n  background: white;\n}\n.str-chat__message-actions-box .str-chat__message-actions-list-item-button:hover {\n  background-color: #2F2047 !important;\n  color: white !important;\n}\n\n.str-chat__quoted-message-reply-to-message {\n  color: white;\n}\n\n/* Recipient pill in input header */\n.recipient-pill {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px 6px 10px;\n  border-radius: 9999px;\n}\n\n.recipient-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 9999px;\n  background: #7c3aed;\n  color: #fff;\n  font-size: 12px;\n}\n\n.recipient-select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  border: none;\n  color: #e5e7eb;\n  font-weight: 600;\n  font-size: 14px;\n  padding-right: 24px;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recipient-select option {\n  background: #374151;\n  color: #e5e7eb;\n  padding: 8px 12px;\n}\n\n.recipient-select:focus {\n  outline: none;\n}\n\n.recipient-caret {\n  position: absolute;\n  right: 8px;\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 7px solid #e5e7eb;\n  pointer-events: none;\n}\n\n/* Message bubble text wrapping */\n.str-chat__message-text,\n.str-chat__message-text p,\n.str-chat__message-text div,\n.msg-bubble p {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n  overflow-wrap: break-word !important;\n  hyphens: auto !important;\n  max-width: 100% !important;\n}\n\n/* Ensure message bubbles handle overflow properly */\n.str-chat__message-bubble {\n  max-width: 100% !important;\n  overflow-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* Pinned messages container */\n.pinned-messages-container {\n  margin: 8px 12px;\n  padding: 0;\n  border-bottom: 0.15px solid #ffffff;\n}\n\n.pinned-label-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  padding-left: 44px; \n}\n\n.pinned-label {\n  font-size: 12px;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 500;\n}\n\n.pinned-message-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 12px;\n  position: relative;\n}\n\n.pinned-avatar {\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n}\n\n.pinned-avatar-image {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.pinned-avatar-fallback {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #52BE80; /* Green color */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 14px;\n  color: white;\n}\n\n.pinned-message-bubble {\n  flex: 1 1 auto;\n  min-width: 0;\n  background-color: #242626; /* Dark grey */\n  border-radius: 14px;\n  padding: 10px 14px;\n  color: white;\n}\n\n.pinned-message-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  font-size: 12px;\n}\n\n.pinned-message-author {\n  font-weight: 600;\n  color: #52BE80; /* Green color */\n}\n\n.pinned-message-time {\n  color: #9ca3af; /* Light grey */\n  font-size: 11px;\n}\n\n.pinned-message-text {\n  color: white;\n  font-size: 14px;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  line-height: 1.4;\n}\n\n.pinned-message-menu {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  padding-top: 4px;\n}\n\n.pinned-menu-wrapper {\n  position: relative;\n}\n\n.pinned-menu-button {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: color 0.2s, background-color 0.2s;\n}\n\n.pinned-menu-button:hover {\n  color: white;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.pinned-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 4px;\n  background-color: #374151;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);\n  min-width: 120px;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.pinned-menu-dropdown-item {\n  width: 100%;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  color: #e5e7eb;\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.pinned-menu-dropdown-item:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.str-chat__user-item--name{\n  color: white !important;\n}\n\n.str-chat__message-reaction-count{\n  color: white !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
